export default function isCreatingTask(taskId: string): boolean {
    return taskId === 'CREATING';
}
